"use client";
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import Image from "next/image";
import { useTranslations } from 'next-intl';

const Feed = () => {
  const t = useTranslations('home.feed');

  // Get feed data from translations
  // t.raw returns objects with numeric keys, convert to array
  const textsObj = t.raw('texts');
  const feedData = {
    texts: textsObj ? Object.values(textsObj) : [],
    speed: t.raw('speed')
  };

  if (feedData) {

    return (
      <div className="bg-[#FFE098] h-[42px] md:h-[55px] overflow-hidden flex items-center text-[#2B2B2BE0]">
        <div className="w-full max-w-[1400px] mx-auto px-4">
          <Swiper
            spaceBetween={10}
            slidesPerView="auto"
            centeredSlides={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={feedData.speed || 5000}
            loop={true}
            allowTouchMove={false}
            modules={[Autoplay]}
            className="h-full feed-slider"
            style={{
            '--swiper-wrapper-transition-timing-function': 'linear',
          }}
          >{Array.isArray(feedData.texts) &&
            feedData.texts.map((text, index) => (
              <SwiperSlide key={index} className="!flex items-center !w-auto ">
                <span className="text-[15px] md:text-[22px]">{text}</span>
                <Image
                  src="/images/star.svg"
                  alt="Star Icon"
                  width={23}
                  height={24}
                  className='ml-[10px] md:w-[23px] md:h-[24px] w-[16px] h-[16px] opacity-88'
                />
              </SwiperSlide>
            ))}
            
          </Swiper>
        </div>
      </div>
    )
  };
};

export default Feed;
